// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import UserPageHeader from '../components/UserPageHeader';


// const AppointmentHistoryPage = () => {
//   const [appointments, setAppointments] = useState([]);
//   const [expandedAppointmentId, setExpandedAppointmentId] = useState(null);

//   useEffect(() => {
//     axios.get('https://carrentalbackend.dockyardsoftware.com/api/Bookings')
//       .then(response => {
//         setAppointments(response.data);
//       })
//       .catch(error => {
//         console.error("There was an error fetching the appointment data!", error);
//       });
//   }, []);

//   const handleToggleDetails = (appointmentId) => {
//     setExpandedAppointmentId(prevId => prevId === appointmentId ? null : appointmentId);
//   };

//   return (
//     <div className="appointment-history-page">
//       <UserPageHeader />
//       <div className="appointment-history-container">
//         <h2 className="appointment-history-title">Appointment History</h2>
//         {appointments.length === 0 ? (
//           <p className="no-appointments-text">No appointment history available.</p>
//         ) : (
//           appointments.map(appointment => (
//             <div key={appointment.id} className="appointment-card">
//               <div className="appointment-summary" onClick={() => handleToggleDetails(appointment.id)}>
//                 <div className="appointment-details">
//                   <p><strong>Car:</strong> {appointment.carName} ({appointment.carType})</p>
//                   <p><strong>Date:</strong> {new Date(appointment.pickupDate).toLocaleDateString()}</p>
//                   <p><strong>Location:</strong> {appointment.pickupLocation}</p>
//                 </div>
//                 <div className="toggle-details">
//                   {expandedAppointmentId === appointment.id ? 'Hide Details' : 'View Details'}
//                 </div>
//               </div>
//               {expandedAppointmentId === appointment.id && (
//                 <div className="appointment-expanded-details">
//                   <p><strong>Return Date:</strong> {new Date(appointment.dropoffDate).toLocaleDateString()}</p>
//                   <p><strong>Vehicle Type:</strong> {appointment.carType}</p>
//                   <p><strong>Capacity:</strong> {appointment.carCapacity}</p>
//                   <p><strong>Rental Rate:</strong> {appointment.carPerDay} per day</p>
//                   <p><strong>Name:</strong> {appointment.name}</p>
//                   <p><strong>Phone Number:</strong> {appointment.phoneNumber}</p>
//                   <p><strong>Address:</strong> {appointment.address}</p>
//                   <p><strong>Town/City:</strong> {appointment.townCity}</p>
//                   <p><strong>Pickup Time:</strong> {appointment.pickupTime}</p>
//                   <p><strong>Dropoff Time:</strong> {appointment.dropoffTime}</p>
//                   <p><strong>Dropoff Location:</strong> {appointment.dropoffLocation}</p>
//                 </div>
//               )}
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default AppointmentHistoryPage;




import React, { useState, useEffect } from "react";
import axios from "axios";
import UserPageHeader from "../components/UserPageHeader";
import carRental from "../assets/carrental.jpg";
import { useNavigate } from 'react-router-dom';

const AppointmentHistoryPage = () => {
  const today = new Date();
  const [appointments, setAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [expandedAppointmentId, setExpandedAppointmentId] = useState(null);
  const [currentWeekStart, setCurrentWeekStart] = useState(getStartOfWeek(new Date()));
  const [selectedMonth, setSelectedMonth] = useState(today.getMonth());
  const [selectedYear, setSelectedYear] = useState(today.getFullYear());
  const navigate = useNavigate();

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = () => {
    axios
      .get("https://carrentalbackend.dockyardsoftware.com/api/Bookings")
      .then((response) => {
        // Filter out rejected appointments (matching admin status values)
        const filteredAppointments = response.data.filter(
          appointment => appointment.status !== "Rejected"
        );
        setAppointments(filteredAppointments);
      })
      .catch((error) => console.error("Error fetching appointment data!", error));
  };

  useEffect(() => {
    filterAppointmentsByDate(selectedDate);
  }, [selectedDate, appointments]);

  function getStartOfWeek(date) {
    const start = new Date(date);
    start.setDate(start.getDate() - start.getDay()); 
    return start;
  }

  const getWeekDates = (startDate) => {
    const weekDates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      weekDates.push(date);
    }
    return weekDates;
  };
  

  const handlePrevWeek = () => {
    const prevWeek = new Date(currentWeekStart);
    prevWeek.setDate(currentWeekStart.getDate() - 7);
    setCurrentWeekStart(prevWeek);
  };

  const handleNextWeek = () => {
    const nextWeek = new Date(currentWeekStart);
    nextWeek.setDate(currentWeekStart.getDate() + 7);
    setCurrentWeekStart(nextWeek);
  };

  const handleMonthChange = (e) => {
    const newMonth = parseInt(e.target.value); 
    setSelectedMonth(newMonth);
    updateCalendar(newMonth, selectedYear);
  };

  const handleYearChange = (e) => {
    const newYear = parseInt(e.target.value);
    setSelectedYear(newYear);
    updateCalendar(selectedMonth, newYear);
  };

  const updateCalendar = (month, year) => {
    const newDate = new Date(year, month, 1);
    setCurrentWeekStart(getStartOfWeek(newDate));
  };

  const filterAppointmentsByDate = (date) => {
    // Create a date-only string for comparison (ignoring time and timezone)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    
    const filtered = appointments.filter(
      (appointment) => {
        // Extract just the date part from the appointment's pickupDate
        const appointmentDate = new Date(appointment.pickupDate);
        const appointmentYear = appointmentDate.getFullYear();
        const appointmentMonth = String(appointmentDate.getMonth() + 1).padStart(2, '0');
        const appointmentDay = String(appointmentDate.getDate()).padStart(2, '0');
        const appointmentDateStr = `${appointmentYear}-${appointmentMonth}-${appointmentDay}`;
        
        return appointmentDateStr === formattedDate;
      }
    );
    setFilteredAppointments(filtered);
  };

  const toggleDetails = (appointmentId) => {
    if (expandedAppointmentId === appointmentId) {
      setExpandedAppointmentId(null);
    } else {
      setExpandedAppointmentId(appointmentId);
    }
  };

  // Function to display status badge with appropriate color
  const renderStatusBadge = (status) => {
    let badgeColor = "";
    switch(status) {
      case "Approved":
        badgeColor = "bg-green-100 text-green-800";
        break;
      case "Pending":
        badgeColor = "bg-yellow-100 text-yellow-800";
        break;
      case "Rejected":
        badgeColor = "bg-red-100 text-red-800";
        break;
      case "Released":
        badgeColor = "bg-blue-100 text-blue-800";
        break;
      default:
        badgeColor = "bg-gray-100 text-gray-800";
    }
    
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${badgeColor}`}>
        {status === "Approved" ? "Booked" : status}
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <UserPageHeader />
      <div className="max-w-6xl mx-auto -mt-10 p-8">
        <div className="mt-28"></div>
        {/* Header Section */}
        <div className="bg-white shadow-md rounded-xl p-6 flex justify-between items-center mt-10">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Add Booking in your schedule now</h2>
            <button 
             onClick={() => navigate('/userpage')}
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg font-medium shadow-md hover:bg-blue-600">
              
              + Add Booking
            </button>
          </div>
          <img src={carRental} alt="Car Rental" className="w-40 h-auto" />
        </div>
        <div className="bg-white shadow-md rounded-xl mt-6 p-6">
        <div className="flex justify-between items-center text-gray-700 font-medium">
        <div className="flex gap-2">
          <select
            value={selectedMonth}
            onChange={handleMonthChange}
            className="border px-3 py-1 rounded-lg bg-gray-100 text-gray-700"
          >
            {Array.from({ length: 12 }).map((_, i) => (
              <option key={i} value={i}>
                {new Date(0, i).toLocaleString("default", { month: "long" })}
              </option>
            ))}
          </select>
          <select
            value={selectedYear}
            onChange={handleYearChange}
            className="border px-3 py-1 rounded-lg bg-gray-100 text-gray-700"
          >
            {Array.from({ length: 10 }, (_, i) => selectedYear - 5 + i).map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div className="flex gap-2">
          <button
            className="border px-3 py-1 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
            onClick={handlePrevWeek}
          >
            ◀
          </button>
          <button
            className="border px-3 py-1 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
            onClick={handleNextWeek}
          >
            ▶
          </button>
        </div>
      </div>

      {/* Days of the Week */}
      <div className="grid grid-cols-7 gap-2 mt-4 text-center text-gray-600">
        {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((day) => (
          <div key={day} className="font-semibold">{day}</div>
        ))}
      </div>

      {/* Dates for the current week */}
      <div className="grid grid-cols-7 gap-2 text-center text-gray-700 mt-2">
        {getWeekDates(currentWeekStart).map((date) => (
          <div
            key={date.toISOString()}
            className={`p-2 rounded-full cursor-pointer transition ${
              selectedDate.toDateString() === date.toDateString()
                ? "bg-blue-500 text-white"
                : "hover:bg-gray-200"
            }`}
            onClick={() => setSelectedDate(date)}
          >
            <div className="text-sm">{date.toLocaleString("default", { month: "short" })}</div>
            <div className="font-bold">{date.getDate()}</div>
          </div>
        ))}
      </div>
        </div>
   
   
        {/* Appointments List */}
        <div className="bg-white shadow-md rounded-xl mt-6 p-6">
          <h3 className="text-lg font-semibold text-gray-800">Bookings on {selectedDate.toDateString()}</h3>
          
          {filteredAppointments.length === 0 ? (
            <p className="text-center text-gray-600 text-lg">No bookings on this date.</p>
          ) : (
            filteredAppointments.map((appointment) => (
              <div key={appointment.id} className="mt-4 border-l-4 border-blue-500 pl-4">
                <div
                  className="flex justify-between items-center cursor-pointer py-3"
                  onClick={() => toggleDetails(appointment.id)}
                >
                  <div>
                    <div className="flex items-center gap-2">
                      <p className="text-lg font-semibold text-gray-800">{appointment.carName} ({appointment.carType})</p>
                      {renderStatusBadge(appointment.status)}
                    </div>
                    <p className="text-gray-600"><strong>Time:</strong> {appointment.pickupTime}</p>
                    <p className="text-gray-600"><strong>Location:</strong> {appointment.pickupLocation}</p>
                  </div>
                  <span className="text-blue-500 font-medium hover:underline">
                    {expandedAppointmentId === appointment.id ? "Hide Details" : "View Details"}
                  </span>
                </div>

                {/* Expanded Details */}
                {expandedAppointmentId === appointment.id && (
                  <div className="mt-4 transition-all duration-300 ease-in-out">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700 mt-2">
                      <p><strong>Return Date:</strong> {new Date(appointment.dropoffDate).toLocaleDateString()}</p>
                      <p><strong>Vehicle Type:</strong> {appointment.carType}</p>
                      <p><strong>Capacity:</strong> {appointment.carCapacity}</p>
                      <p><strong>Rental Rate:</strong> {appointment.carPerDay} per day</p>
                      <p><strong>Name:</strong> {appointment.name}</p>
                      <p><strong>Phone:</strong> {appointment.phoneNumber}</p>
                      <p><strong>Address:</strong> {appointment.address}</p>
                      <p><strong>Town/City:</strong> {appointment.townCity}</p>
                      <p><strong>Dropoff Time:</strong> {appointment.dropoffTime}</p>
                      <p><strong>Dropoff Location:</strong> {appointment.dropoffLocation}</p>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentHistoryPage;